// @flow
import { useContext } from 'react';
import {
  convertArrayToMapByProperties,
  convertObjectOfKeyAndArrayToMapWithSetValues,
} from '@src/common-utils/utils';
import {
  getMetricNameToAggregatedUsageMapForKafkaMetrics,
  getMetricUsageMapWithOnlyNonZeroValuesAndNonEmptyMetricObjects,
} from '@components/custom-discounts/mld-for-field/utils';

import { EstimateContext } from '../contexts/EstimateContext';

export const useEstimateMLDForFieldGuidance = () => {
  const estimate = useContext(EstimateContext);

  const {
    usages = [],
    ae_discount_guidance: aeDiscountGuidance = [],
    connector_tier_mapping: connectorTierMapping,
  } = estimate?.mld_guidance || {};

  const metricNameToUsagesMapBeforeFilteringOutZeroValues = convertArrayToMapByProperties(
    usages,
    'metric_name',
    'dimension_combination_usages'
  );

  const metricNameToUsagesMap = getMetricUsageMapWithOnlyNonZeroValuesAndNonEmptyMetricObjects(
    metricNameToUsagesMapBeforeFilteringOutZeroValues
  );

  const metricNameToAEDiscountGuidanceMap = convertArrayToMapByProperties(
    aeDiscountGuidance,
    'metric',
    'guidance'
  );

  const metricNameToAggregatedUsageMapBasedOnGuidanceForKafkaMetrics =
    getMetricNameToAggregatedUsageMapForKafkaMetrics(
      metricNameToUsagesMap,
      metricNameToAEDiscountGuidanceMap
    );

  const connectTierMappingMap = convertObjectOfKeyAndArrayToMapWithSetValues(connectorTierMapping);

  return {
    metricNameToUsagesMap,
    metricNameToAEDiscountGuidanceMap,
    connectTierMappingMap,
    metricNameToAggregatedUsageMapBasedOnGuidanceForKafkaMetrics,
  };
};
